<template>
  <ListVerval
    :type="type"
    :title="configs[type]['title']"
    :access="configs[type]['access']"
    :actions="configs[type]['actions']"
  />
</template>
<script>
import ListVerval from './List';
import actionsVervalGuru from './actions/guru';
import actionsVervalPaud from './actions/paud';
export default {
  components: { ListVerval },

  computed: {
    type() {
      const diklat = {
        'pkp-verval': 'diklat-verval',
        'pkp-verval-paud': 'diklat-verval-paud',
      };

      return diklat[this.$route.name];
    },

    configs() {
      return {
        'diklat-verval': {
          title: 'Peserta Diklat PKP',
          access: 'psp-peserta-diklat-verval',
          actions: actionsVervalGuru,
        },
        'diklat-verval-paud': {
          title: 'Peserta Diklat PKP PAUD',
          access: 'psp-peserta-diklat-verval-paud',
          actions: actionsVervalPaud,
        },
      };
    },
  },
};
</script>
